import {
    THICKNESS_LIST_GET,
    THICKNESS_LIST_GET_F,
    THICKNESS_LIST_GET_R,
    THICKNESS_SELECTED_SET
} from '../actionType'

const initialState = {
    thickness: [],
    isLoading: false,
    error: null,
    totalPage: 0,
    totalElement: 0,
    selectedThickness: null,
}

export default function ThicknessReducer (state = initialState, action : any)  {
    switch (action.type) {
        case THICKNESS_LIST_GET:
            return {
            ...state,
            isLoading: true,
            error: null
            }
        case THICKNESS_LIST_GET_F:
            // console.log('action called')
            // console.log(action.payload.content,'content')
            return {
                ...state,
                isLoading: false,
                thickness: action.payload.content,
                totalPage: action.payload.total_page,
                totalElement: action.payload.total_element
            }
        case THICKNESS_LIST_GET_R:
            
            return {
                ...state,
                isLoading: false,
                error: action.payload
            }
        case THICKNESS_SELECTED_SET:
            return {
                ...state,
                selectedThickness: action.payload
            }
        default:
            return state
    }
}